export default "__VITE_ASSET__eCXdjZIp__"